import { API, Auth } from 'aws-amplify';
import store from './store'

const apiName = 'DZI';
const apiStage = 'prod';
const defaultApiKey = 'nlPKR4zSEA1wXXuWMvnHsaZxyLkElANk6TSpVGSV';
                   
export default {
    async myInit () {
        let authHeader = 'SecretKey ' + defaultApiKey;
        
        await Auth.currentSession().then(session => {
            let jwtToken = session.getAccessToken().getJwtToken();
            if (store.state.clientId)
            {
                jwtToken += ' ' + store.state.clientId;
            }
            authHeader = 'Bearer ' + jwtToken;
        }).catch(err => {
            store.commit('setError', 'Auth error: ' + err);
        });
                
        return { 
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json', 
                'x-api-key': defaultApiKey,
                Authorization: authHeader 
            }
        }
    },
    async get(path) {
        return await API.get(apiName, '/' + apiStage + path, await this.myInit()).catch(err => { store.commit('setError', 'API error: ' + err); });
    },
    async delete(path) {
        return await API.del(apiName, '/' + apiStage + path, await this.myInit()).catch(err => { store.commit('setError', 'API error: ' + err); });
    },
    async post(path, body) {
        let myInit = await this.myInit();
        myInit.body = body; 
        return await API.post(apiName, '/' + apiStage + path, myInit).catch(err => { 
            if (err.response.status==422)
            {
                return err.response.data;
            }
            else
            {
                store.commit('setError', 'API error: ' + err); 
                return err;
            }
        });
    },
    async patch(path, body) {
        let myInit = await this.myInit();
        myInit.body = body; 
        return await API.patch(apiName, '/' + apiStage + path, myInit).catch(err => { store.commit('setError', 'API error: ' + err); });
    },
    async ping() {
        return this.get('/ping')
    },
    async getDevices() {
        return await this.get('/device');
    },
    async getDeactivatedDevices () {
        return await this.get('/device/deactivated')
    },
    async getAliases () {
        return await this.get('/alias')
    },
    async getAlias (id) {
        return await this.get('/alias/' + id)
    },
    async getAliasHistory (id) {
        return await this.get('/alias/' + id + '/history');
    },
    async getDevice (id) {
        return await this.get('/device/' + id)
    },
    async getDeactivatedDevice (id, timestamp) {
        return await this.get('/device/' + id + '/' + timestamp)
    },
    async getDeviceHistory (id, start, end) {
        if (!end) end = (new Date()).getTime();
        if (!start) start = end - (30*24*3600*1000);
        return await this.get('/device/' + id + '/history?start='+start+'&end=' + end);
    },
    async deactivateDevice (id) {
        return await this.post('/device/deactivate', {'deviceId': id });
    },
    async activateDevice (id, pin) {
        return await this.post('/device/activate', {'deviceId': id, 'pin': pin });
    },
    async update (id, data) {
        return await this.patch('/device/' + id, data);
    },
    async getClients () {
        return await this.get('/client')
    },   
    async getCurrentClient () {
        return await this.get('/current/client')
    },   
    async getUsers () {
        return await this.get('/user')
    },
    async addUser (email, role) {
        return await this.post('/user', {'email': email, 'role': role });
    },
    async deleteUser (userId) {
        return await this.delete('/user/' + userId);
    },
    async deleteInvitation (email) {
        return await this.delete('/user/invite/' + email);
    },
    async getInvites () {
        return await this.get('/user/invite')
    },   
    async createClient (data) {
        return await this.post('/client', data);
    },
}                                     